module.exports = __webpack_public_path__ + "static/media/dotted.b8326b15.svg";